import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MAPS_EXPORT_MAP_ASSET_TYPE} from "#material-outputs-filenames/types"

export const organizationName = "hugo boss" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
        jpeg: "jpg",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // maps exports maps
    {
        type: MAPS_EXPORT_MAP_ASSET_TYPE,
        schema: "$MATERIAL_NAME$_$MAP_TYPE$.$EXPORT_FORMAT$",
        options,
    },
]
